const infos = [
  {
    icon: 'ri-phone-line',
    label: '電話',
    en: 'TEL',
    value: '+886-2-2651-6999',
    href: 'tel:+886226516999',
    linkable: true,
  },
  {
    icon: 'ri-printer-line',
    label: '傳真',
    en: 'FAX',
    value: '+886-2-2653-0383',
    href: null,
    linkable: false,
  },
  {
    icon: 'ri-mail-line',
    label: '電子郵件',
    en: 'E-MAIL',
    value: 'service@electronicsworld.com.tw',
    href: 'mailto:service@electronicsworld.com.tw',
    linkable: true,
  },
  {
    icon: 'ri-map-pin-2-line',
    label: '公司地址',
    en: 'ADDRESS',
    value: '台北市南港區南港路三段99號9樓',
    sub: '9F, No.99, Sec.3, Nankang Rd., Taipei, Taiwan',
    href: null,
    linkable: false,
  },
];

export default function ContactInfo() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {infos.map(info => (
        <div
          key={info.en}
          className="border border-gray-100 hover:border-[#1a73b5] transition-colors p-5 flex flex-col items-center text-center group"
        >
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1a73b5]/10 group-hover:bg-[#1a73b5] transition-colors mb-3">
            <i className={`${info.icon} text-[#1a73b5] group-hover:text-white text-xl transition-colors`} />
          </div>
          <p className="text-xs tracking-widest text-gray-400 uppercase mb-0.5">{info.en}</p>
          <p className="text-sm font-semibold text-gray-800 mb-1">{info.label}</p>
          {info.linkable && info.href ? (
            <a
              href={info.href}
              className="text-sm text-[#1a73b5] hover:underline cursor-pointer break-all leading-snug"
            >
              {info.value}
            </a>
          ) : (
            <p className="text-sm text-gray-600 leading-snug">{info.value}</p>
          )}
          {'sub' in info && info.sub && (
            <p className="text-xs text-gray-400 mt-1 leading-snug">{info.sub}</p>
          )}
        </div>
      ))}
    </div>
  );
}
